import { createContext, useState } from "react";
import ProblemsTable from "./components/ProblemsTable";
export type contextType={
    tableData:any[],
    setTableData:(params:any)=>void
    edit:any|null;
    setEdit:(params:any)=>void
    success:boolean,
    setSuccess:(params:boolean)=> void
 }
 export const ProblemsContext=createContext<contextType|null>(
  {
    tableData:[],
    setTableData:()=>{},
    edit:[],
    setEdit:()=>{},
    success:false,
    setSuccess:()=>{}

 })
function Problems() {
    const [tableData,setTableData]=useState([])
    const [edit,setEdit]=useState<any[]|null>(null)
    const [success,setSuccess]=useState<boolean>(false)
  return (
            <ProblemsContext.Provider  value={{tableData,setTableData,edit,setEdit,success,setSuccess}} >
                <ProblemsTable/>
            </ProblemsContext.Provider>
  )
}

export default Problems
